<template>
    <v-card :color="getColorCard" class="card-container kimsa-elevation" @click="$emit('click')">
        <v-icon :color="isActive ? '#FFFFFF' : '#000000'" size="88" class="pa-3">
            {{ category.icon }}
        </v-icon>
        <div class="bolder" :class="[{ 'white--text': isActive }]">
            {{ category.name }}
        </div>
    </v-card>
</template>

<script>
export default {
    name: "CategoryCard",
    props: {
        createMode: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        category: {
            type: Object,
            default: null,
        },
    },
    computed: {
        getColorCard(vm = this) {
            if (vm.createMode) return '#CCFF99'
            return vm.isActive ? 'secondary' : ''
        }
    },
}
</script>

<style scoped>
.card-container {
    text-align: center;
    overflow: hidden;
    border-radius: 0;
}
</style>